import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@workboard/action-item';
import { StateListProps } from '../../../types/sidePanel.types';
import * as SidePanelAction from '../../../actions/sidePanel.actions';
import { updateWsGraphData } from '../../../utils/board';
import { useOnClickOutside } from '../../../../hooks/useOnClickOutside';
import { IconStateWrapper } from './iconWrapper';

const StateListComp = (props: StateListProps) => {
  const { t } = useTranslation();
  const {
    aiId, columnId, tagId, srcVal, values
  } = props;
  const [stateRef] = useOnClickOutside(() => {
    if (typeof props.hideShowListPopup === 'function') {
      props.hideShowListPopup();
    }
  });

  const onStateChanges = (item) => {
    if (srcVal == 'act') {
      if (aiId) {
        props.hideShowListPopup();
        props.dispatch(SidePanelAction.boardAiStateChange(aiId, item.value, columnId));
        $.post(
          `${wbConfig.baseUrl}/activity/state_act`,
          { state: item.value, act_id: aiId },
          () => {
            updateWsGraphData(tagId);
          }
        );
      }
    } else if (srcVal == 'automation') {
      props.saveTitleAndValue(
        'statusTitle',
        item.label,
        'statusVal',
        item.value
      );
    }
  }

  const automationClass = (srcVal == 'automation') ? 'automationAttrWidth' : '';

  if (srcVal == 'automation') {
    values.unshift({ value: '', label: t('None') });
  }

  return (
    <div ref={stateRef} className={`statusListDivOuterWrap ${automationClass}`}>
      <div className="attrLabel">{t('STATUS')}</div>
      {
        values.map((item: any, index) => (
          <div
            key={`status_${item.value}`}
            className="statusVal attrValFont clickable "
            data-value={item.value}
            onClick={() => onStateChanges(item)}
          >
            <IconStateWrapper isSourceFromAct={(srcVal == 'act')}>
              {
                item?.icons?.component
                  ? <Icon name={item?.icons?.component} width="16" height="16" />
                  : <span>&nbsp;</span>
              }
            </IconStateWrapper>
            <div className="displayInlineB">{item.label}</div>
          </div>
        ))}
    </div>
  );
}
export default StateListComp;
